import Icon from 'components/Icon';
import { FooterLink as Link } from './components';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="wrapper">
        <div className="row">
          <div className="col col-3 col-tablet-1 footer__logo-col">
            <Link className="logo" to="/">
              <Icon icon="logo" />
            </Link>
          </div>
          <div className="col col-9 col-tablet-12">
            <div className="footer__nav _mb-75 _mb-tablet-54">
              <div className="footer__nav-col footer__nav-col_1 _mb-note-20">
                <div className="footer__nav-title _mb-16">Platform</div>
                <ul className="footer__nav-list">
                  <li className="_mb-6">
                    <Link to="/website-builder">Website Builder</Link>
                  </li>
                  <li className="_mb-6">
                    <Link to="/online-store">Online Store</Link>
                  </li>
                  <li>
                    <Link to="/templates">Templates</Link>
                  </li>
                </ul>
              </div>
              <div className="footer__nav-col footer__nav-col_2">
                <div className="footer__nav-title _mb-16">Integration</div>
                <ul className="footer__nav-list">
                  <li className="_mb-6">
                    <Link to="/simple-integration#siteplusApi" preventScroll>
                      Siteplus API
                    </Link>
                  </li>
                  <li className="_mb-6">
                    <Link to="/simple-integration#cPanel" preventScroll>
                      cPanel Plugin
                    </Link>
                  </li>
                  <li className="_mb-6">
                    <Link to="/simple-integration#whmcs" preventScroll>
                      WHMCS Plugin
                    </Link>
                  </li>
                  <li>
                    <Link to="/simple-integration#plesk" preventScroll>
                      Plesk Plugin
                    </Link>
                  </li>
                </ul>
              </div>
              <div className="footer__nav-col footer__nav-col_3">
                <div className="footer__nav-title _mb-16">Support</div>
                <ul className="footer__nav-list">
                  <li className="_mb-6">
                    <Link to="/help">Help Center</Link>
                  </li>
                  <li className="_mb-6">
                    <Link to="/legal/terms">Terms of Service</Link>
                  </li>
                  <li className="_mb-6">
                    <Link to="/legal/privacy">Privacy Policy</Link>
                  </li>
                  <li>
                    <Link to="/legal/gdpr">GDPR</Link>
                  </li>
                </ul>
              </div>
              <div className="footer__nav-col footer__nav-col_4">
                <div className="footer__nav-title _mb-16">About</div>
                <ul className="footer__nav-list">
                  <li className="_mb-6">
                    <Link to="/about-us">Our Story</Link>
                  </li>
                  <li className="_mb-6">
                    <Link to="/about-us/our-lifestyle">Our Lifestyle</Link>
                  </li>
                  {/*
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li> */}
                </ul>
              </div>
            </div>
          </div>
          <div className="col col-12 col-tablet-11 footer__text-col">
            <p className="text footer__text">
              Copyright &#169; 2025 Siteplus, Pte Ltd. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
